import { api } from '@creditsights/api-ui-web';
import { FundamentalsMetrics, RiskOverviewMetrics, RiskProductsData } from '../../models/RiskProducts';

export const riskProductsUri = '/risk-products/v1';

export const getRiskProductUrl = (companyId: string): string => `${riskProductsUri}/company/${companyId}/riskoverview`;
export const getFundamentalsUrl = (companyId: string): string => `${riskProductsUri}/company/${companyId}/fundamentals`;

export const fetchCompanyRiskOverview = async (companyId: string): Promise<RiskOverviewMetrics> => {
  const resp = await api.get(getRiskProductUrl(companyId));
  return resp?.data?.data;
};

export const fetchCompanyChart = async (companyId: string): Promise<RiskProductsData> => {
  const resp = await api.get(`${riskProductsUri}/company/${companyId}/chart`);
  return resp.data;
};

export const fetchCompanyFundamentals = async (companyId: string): Promise<FundamentalsMetrics> => {
  const resp = await api.get(getFundamentalsUrl(companyId));
  return resp?.data;
};
